// Tracks whether the app has finished its initial (prerendered) render.
//
// Editorial pages now paint a static hero shim into #root at build time; when
// React mounts via createRoot it replaces that shim. If a hero runs a
// framer-motion entrance animation (opacity 0 → 1), the headline would flash
// — visible in the shim, then invisible as React's `initial` state takes over,
// then fade back in. To avoid that, heroes read `appHasMounted()` at mount:
//   • false  → this is the first paint over the shim → render the final state
//              immediately (no entrance), so the swap is seamless.
//   • true   → a later client-side navigation → animate the entrance normally.
//
// `markAppMounted()` is called from main.tsx one frame after the initial
// render, so the very first hero instance reads `false` and every subsequent
// (navigation) instance reads `true`.
let mounted = false;

export const appHasMounted = (): boolean => mounted;

export const markAppMounted = (): void => {
  mounted = true;
};
